<template>
  <BaseLayout>
    <div class="page-single position-relative">
      <b-container
        fluid
      >
        <b-row class="justify-content-center">
          <b-col
            cols="10"
            md="8"
            lg="7"
            xl="5"
          >
            <div
              class="d-flex align-items-center justify-content-center"
            >
              <b-card>
                <b-card-title
                  style="font-size: 28px;"
                >
                  Forgotten your Password?
                </b-card-title>
                <b-card-text>
                  Please check the inbox of <span class="font-weight-bold">{{ user.email }}</span> for our email containing your password reset link, which will expire in 1 hour. After that, you will need to submit a new password reset request.
                </b-card-text>
              </b-card>
            </div>
            <div class="text-center text-muted mt-4">
              Need support? Contact our team <a
                href="mailto:support@smartology.net"
                target="_blank"
              >support@smartology.net</a>
            </div>
          </b-col>
        </b-row>
        <div
          class="header-brand d-flex justify-content-center mb-5 mr-0 smartology-logo-footer"
          style="z-index: 0;"
        >
          <a
            target="_blank"
            href="https://www.smartology.net/"
          >
            <img
              src="/images/logo.png"
              class="h-7 header-brand-img mr-0"
              alt="Smartology"
            >
          </a>
        </div>
      </b-container>
    </div>
  </BaseLayout>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'VerifyForgottenPassword',
  computed: {
    ...mapState('authentication', [
      'user',
    ]),
  },
  created() {
    if (!this.user?.email) {
      this.$router.push('/forgot-password');
    }
  },
};
</script>
